module.exports = __webpack_public_path__ + "img/cca-logo.f89c3b87.svg";